(function () {
    'use strict';

    angular.module('swif.framework')
    .factory('swifModule', swifModule);


    /**
    * @ngdoc service
    * @name swif.framework.swifModule
    * @requires swif.framework.dataService
    * @requires swif.framework.settingsService
    **/
    function swifModule($interval, settings) {
        'ngInject';
        var service = {};
        service.modules = {};
        settings.initialize().then(function (settings) {
            _.merge(service.modules, settings.app.modules);
        });
        service.getModule = function (name) {
            switch (name) {
            case 'inter':
                name = 'openstc';
                break;
            case 'resa':
                name = 'openresa';
                break;
            case 'achat':
                name = 'openstc_achat_stock';
                break;
            case 'stock':
                name = 'openstc_achat_stock';
                break;
            case 'patrimoine':
                name = 'openstc_patrimoine';
                break;
            case 'auto':
                name = 'opengst_parcauto';
                break;
            case 'fluide':
                name = 'opengst_fluide';
                break;
            case 'base':
                name = 'openbase';
                break;
            }
            return service.modules[name];
        };
        service.hasModule = function (name) {
            return !_.isUndefined(service.getModule(name));
        };
        service.hasModules = function (names) {
            var result = true;
            _.forEach(names, function (name) {
                result = result && service.hasModule(name);
            });
            return result;
        };
        service.names = {
            'openstc': 'Interventions',
            'openstc_patrimoine': 'Patrimoine',
            'openresa': 'Reservations',
            'openstc_achat_stock': 'Achats',
            'opengst_parcauto': 'Parc auto',
            'opengst_fluide': 'Fluides',
            'openbase': 'Configuration'
        };
        service.nameByIds = {};
        service.nameByModele = {
            'openresa.request': 'openresa',
            'openstc.ask': 'openstc',
            'openstc.ask.contrib': 'openstc',
            'project.project': 'openstc',
            'project.task': 'openstc',
            'model_purchase_order': 'openstc_achat_stock',
            'mopenbase.model_openbase_log': 'openstc_achat_stock',
            'model_purchase_order_ask_partners': 'openstc_achat_stock',
            'model_openstc_ask_prod': 'openstc_achat_stock'
        };
        service.regex = {
            'mobile': /(0|\+33|0033)[6-7][0-9]{8}$/
        };
        service.vocabulary = [];
        return service;
    }

})();
